"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from "react";
import { useTranslations } from "next-intl";
import { CATEGORIES, CATEGORY_ORDER, tools } from "@/lib/tools";
import { ToolCard } from "@/components/ToolCard";
import { Icon } from "@/lib/icons";
const ALL = "all";
type Filter = string;
export function ToolSearch() {
  const $ = _c(31);
  const [query, setQuery] = useState("");
  const [active, setActive] = useState(ALL);
  const tHome = useTranslations("Home");
  const tCat = useTranslations("Categories");
  const tTools = useTranslations("Tools");
  let t0;
  if ($[0] !== active || $[1] !== query || $[2] !== tTools) {
    const q = query.trim().toLowerCase();
    t0 = tools.filter(tool => {
      const matchesCategory = active === ALL || tool.category === active;
      const localizedName = tTools(`${tool.slug}.name` as any) || tool.name;
      const localizedDesc = tTools(`${tool.slug}.description` as any) || tool.description;
      const matchesQuery = !q || tool.name.toLowerCase().includes(q) || localizedName.toLowerCase().includes(q) || tool.description.toLowerCase().includes(q) || localizedDesc.toLowerCase().includes(q) || tool.keywords.some(k => k.toLowerCase().includes(q));
      return matchesCategory && matchesQuery;
    });
    $[0] = active;
    $[1] = query;
    $[2] = tTools;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const filtered = t0;
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon name="search" className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" />;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => setQuery(e.target.value);
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== tHome) {
    t3 = tHome("searchPlaceholder", {
      count: tools.length
    });
    $[6] = tHome;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== query || $[9] !== t3) {
    t4 = <div className="relative mx-auto max-w-2xl">{t1}<input type="search" value={query} onChange={t2} placeholder={t3} aria-label="Search tools" className="w-full rounded-full border border-slate-300 bg-white py-3 pl-12 pr-4 text-base text-slate-900 shadow-sm outline-none transition focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200" /></div>;
    $[8] = query;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setActive(ALL);
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = `rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${active === ALL ? "bg-indigo-600 text-white" : "bg-white text-slate-700 ring-1 ring-slate-300 hover:bg-slate-50"}`;
  let t7;
  if ($[12] !== tHome) {
    t7 = tHome("searchAll") || "All Tools";
    $[12] = tHome;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <button type="button" onClick={t5} className={t6}>{t7}</button>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== active || $[18] !== tCat) {
    t9 = CATEGORY_ORDER.map(category => <button key={category} type="button" onClick={() => setActive(category)} className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${active === category ? "bg-indigo-600 text-white" : "bg-white text-slate-700 ring-1 ring-slate-300 hover:bg-slate-50"}`}>{tCat(`${category}.label` as any) || CATEGORIES[category].label}</button>);
    $[17] = active;
    $[18] = tCat;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <div className="mt-6 flex flex-wrap items-center justify-center gap-2">{t8}{t9}</div>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== filtered || $[24] !== query || $[25] !== tHome) {
    t11 = filtered.length > 0 ? <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{filtered.map(_temp)}</div> : <p className="mt-12 text-center text-slate-500">{tHome("noResults", {
        query
      }) || "No tools found matching your search."}</p>;
    $[23] = filtered;
    $[24] = query;
    $[25] = tHome;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t4) {
    t12 = <section id="tools" aria-label="Browse our free tools">{t4}{t10}{t11}</section>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t4;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
}
function _temp(tool_0) {
  return <ToolCard key={tool_0.slug} tool={tool_0} />;
}